import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './hr.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

export const hrTypeOptions = ['checkbox', 'radio'];

export default class HR extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * changes the hr color
       */
      color: { type: String },
      /**
       * changes the hr height
       */
      height: { type: Number },
      /**
       * allows injection of a one-off class
       */
      injectVariant: { type: String },
    };
  }

  constructor() {
    super();
    this.color = 'black';
    this.height = 1;
    this.injectVariant = ''
  }

  render() {
    return html`
      <hr class="${classMap({
        'hr': true,
        [`hr--color--${this.color}`]: this.color,
        [`hr--height--${this.height}`]: this.height,
        [`hr--injected-variant--${this.injectVariant}`]: this.injectVariant,
      })}"
      role="presentation">
    `;
  }
}

customElements.define('hf-hr', HR);
